import React, { useState } from "react";

import Content from "./Content";
import Tabs from "./Tabs";

export interface TabProps {
  name: string;
  component: React.ComponentType;

  onTabClick?: Function;
}

interface TabsContainerProps {
  tabs: ReadonlyArray<TabProps>;
  theme?: string;
}

const TabsContainer: React.FC<TabsContainerProps> = (props: TabsContainerProps): JSX.Element => {
  const { tabs, theme = "" } = props;

  const [activeTab, setActiveTab] = useState(tabs[0].name);

  return (
    <div className="caprx-tabs-container-container">
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} theme={theme} />
      <Content activeTab={activeTab} tabs={tabs} theme={theme} />
    </div>
  );
};

export default TabsContainer;
